<template>
  <div id="monitored-races">
    <div class="ml-2 race-filter" v-if="filteredBookie">
      <div class="showing">Showing:</div>
      <div class="mt-6">
        <bookie-icon
          :bookie="filteredBookie"
          :size="30"
          :top="true"
          @click="() => toggleBookieFilter(filteredBookie)"
        />
      </div>
    </div>

    <v-data-iterator
      :items="races"
      no-data-text="No races are currently being monitored"
      :hide-default-footer="!races.length"
      :items-per-page="-1"
      :footer-props="{
        itemsPerPageOptions: [20, 50, 100, -1]
      }"
      class="ml-2"
    >
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <race-panel
              :race="item"
              :show-selections="true"
              :menu="menu"
              @iconClicked="() => toggleBookieFilter(item.bookie)"
            />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <place-bet-dialog
      v-if="selectedRace"
      :race="selectedRace"
      :dialog="placeBetDialog"
      :close="closePlaceBetDialog"
      :confirm="confirmBet"
    />
  </div>
</template>

<script>
import BookieIcon from "../components/BookieIcon";
import RacePanel from "../components/RacePanel";
import PlaceBetDialog from "../components/PlaceBetDialog";
import { placeBet } from "../lib/commands";

export default {
  name: "MonitoredRaces",
  components: {
    RacePanel,
    BookieIcon,
    PlaceBetDialog
  },
  data() {
    return {
      filteredBookie: "",
      selectedRace: null,
      placeBetDialog: false,
      menu: [
        {
          title: "Place Bet",
          action: race => this.showPlaceBetDialog(race)
        },
        {
          title: "Open Betfair",
          action: race => window.open(race.betfair_win_url)
        },
        {
          title: "View Settings",
          action: () => false
        }
      ]
    };
  },
  computed: {
    races() {
      return this.$store.getters.monitoredRaces
        .filter(r =>
          this.filteredBookie ? r.bookie === this.filteredBookie : true
        )
        .sort((a, b) => {
          if (a.bot === "tess") return -1;

          if (b.bot === "tess") return 1;

          if (a.startTime < b.startTime) return -1;

          return a.bookie < b.bookie ? -1 : 1;
        });
    }
  },
  methods: {
    toggleBookieFilter(bookie) {
      if (this.filteredBookie === bookie) {
        this.filteredBookie = null;
      } else {
        this.filteredBookie = bookie;
      }
    },
    showPlaceBetDialog(race) {
      if (this.$store.state.user.email === "dmtaylor17@gmail.com") {
        this.selectedRace = race;
        this.placeBetDialog = true;
      } else {
        this.showError("access denied");
      }
    },
    closePlaceBetDialog() {
      this.selectedRace = null;
      this.placeBetDialog = false;
    },
    async confirmBet(race, selection, stake) {
      this.selectedRace = null;
      this.placeBetDialog = false;

      try {
        const resp = await placeBet(
          race.bot,
          race.id,
          selection.number,
          selection.marketType,
          stake
        );
        if (resp.no_response) {
          this.showError("No response received from bot");
        } else {
          this.showSuccess("Bet sent to Slippy");
        }
      } catch (err) {
        this.showError(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.race-filter {
  display: flex;
  align-items: center;

  .showing {
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
